import React from 'react'

import { Svg, SvgName } from 'components/_new/ui'
import { Box, Row } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import s from './DefaultView.scss'


type DefaultView = Omit<Notifications.StoreItem, 'id'> & {
  onHide: () => void
}

const DefaultView: React.FunctionComponent<DefaultView> = ({ text, title, svgName, onHide }) => (
  <div className={s.container}>
    <button className={s.button} type="button" onClick={onHide}>
      <Box className={s.notification} ph={8} pv={16}>
        <Row justify="start">
          {
            Boolean(svgName) && (
              <Svg className={s.svg} name={svgName as SvgName} />
            )
          }
          <Box pl={svgName ? 8 : null}>
            <Row wrap>
              {
                Boolean(title) && (
                  <Text
                    className={s.text}
                    message={title}
                    size="16-24"
                    align="left"
                    color="brand"
                    semibold
                  />
                )
              }
              {
                Boolean(text) && (
                  <Text
                    className={s.text}
                    message={text}
                    color="black"
                    align="left"
                    size="16-24"
                  />
                )
              }
            </Row>
          </Box>
        </Row>
      </Box>
    </button>
  </div>
)


export default DefaultView
